import React from "react";
import styled from "styled-components";

const SpacerStyled = styled.div(({ size }) => ({
  height: size * 7 + "px",
  "@media (min-width: 768px)": {
    height: size * 9 + "px",
  },
}));

const Spacer = ({ size = 1 }) => {
  return <SpacerStyled size={size} />;
};

export default Spacer;
